import React, { Component } from "react";
import PropTypes, { element } from "prop-types";
import {
  TextInput,
  Button,
  Checkbox,
  RadioButtonGroup,
  FormGroup,
  RadioButton,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownSkeleton,
  MultiSelect,
} from "carbon-components-react";
import SimpleReactValidator from "simple-react-validator";
import { ComboBox } from "../../helpers/ComboBox";
import { FindGHRSEmployer } from "../common/FindGHRSEmployer";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { DateFormat, entitiesLabels } from "../../helpers/Constants";
import DateTimePicker from "../../helpers/DateTimePicker";
import IncidentRepository from "../../helpers/api/IncidentRepository";
import { api, dynamic } from '../../helpers/api/api';
import {
  getSuccess,
  getError,
  apioperation
} from '../../helpers/Constants';
import '../../scss/custom.scss';
import _sortBy from 'lodash/sortBy'; //RITM0946148

export class InjuredPersonModal extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      loading: false, // aggiunto
      idsSelectedBodyParts: [], // aggiunto
      model: {
        ...this.incidentInjuredPersonModel(props),
      },
      // mode: props.mode || 0,
      // CR RITM0583314
      mode: props.mode || 2,
      appJobPosition: null, //RITM0946148
      appJobPositionType: null, //RITM0946148
      rows: props.rows, //RITM1405215
    };
    this.isWorkRestricedCase = 0;
    this.onChange = this.onChange.bind(this); // aggiunto
  }
  // aggiunto
  async componentDidMount() {
    if (this.state.model?.idJobPositionType) this.getJobPostions(this.state.model?.idJobPositionType); //RITM0946148
    this.setState({ loading: true });
    const jobPositionType = (this.props.appJobPositionType || []).filter((el) => el.inUse || this.state.model?.idJobPositionType == el.id) //RITM0946148
    const items = await this.getItems();
    console.log("bodyParts", items);
    this.setState({
      items,
      selectedItems: this.props.initialSelectedItems,
      loading: false,
      appJobPositionType: jobPositionType, //RITM0946148
    });
  }
  // aggiunto
  onChange = (selectedItem) => {
    console.log(selectedItem)
    const items = selectedItem ? selectedItem.selectedItems : null;
    // this.setState({
    //   idsSelectedBodyParts: items?.map((elem) => elem.id),
    // });
    // const itemsId = items?.map((elem) => elem.id)
    const element = items?.map((elem) =>({idBodyParts: elem.id}))
    this.updateState("incidentInjuredPersonBodyPart", element, "model")
  };
  // aggiunto
  getItems = async () => {
    let items = [];
    try {
      items = await IncidentRepository.getBodyParts();
      console.log("PARTS", items);
    } catch (error) {
        console.error(error);
        this.props.onError(error);
    }
    return items;
  };

  incidentInjuredPersonModel = (props) => {
    if (props.isEditModal) {
      return { ...props.editModel };
    }

    return {
      id: null, // guid
      idIncident: null, // guid
      type: null, // ''info orifinator
      subContractor: null, // ''subContractor
      fullname: null, // ''
      nationality: null, // ''
      badgeNumber: null, // ''
      idEmployer: null, // '' as guid
      idInjuryType: null, // guid combobox
      idContractType: null, // guid
      employmentDate: null, // date
      prjJoiningDate: null, // date
      experienceYears: null, // int
      experienceMonths: null, // int
      idShiftDuration: null, // guid
      daysFromShiftStart: null, // int
      hoursFromShiftStart: null, // int
      drugAlchoolTest: null, // bool
      lastSafetyMeeting: null, // date
      lastMedicalCheckAvailable: null, // bool?
      lastMedicalCheck: null, // date
      lastMedicalCheckStatus: null, // combo Valid, Expired
      otherInfo: null, // ''
      daysLost: 0, // int
      restrictedWorkDays: 0,
      dateFit: null, // date
      restrictedActivity: null, // ''
      injuryRecurrent: null, // bool
      idInjurySource: null, // guid
      idInjuryClass: null, // guid
      idJobPositionType: null, //guid //RITM0946148
      idJobPosition: null, //guid //RITM0946148
      GuidBodyPart: [], // guid
      sequence: 0, //RITM1405215
      injuredPersonCode: null, //RITM1405215
    };
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state.model };
    if (objName && objName != "model")
      statusCopy[objName][inputName] = inputValue;
    else statusCopy[inputName] = inputValue;
    if (objName && inputName == "type") statusCopy["idSubContractor"] = null;
    this.setState({ model: statusCopy });
  };

  updateStateDP = (inputName, inputValue, objName) => {
    this.setState((prevState) => ({
      [objName]: {
        ...prevState[objName],
        [inputName]: inputValue,
      },
    }));
  };

  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = el.target.alt;

    this.updateState(inputName, inputValue, objName);
  };

  handleChangeRadio = (value, id, event) => {
    if (value == "true") {
      value = true;
    } else if (value == "false") {
      value = false;
    } else if (value == "null") {
      value = null;
    }

    this.updateState(id, value, event.target.alt);
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    this.updateState(inputName, inputValue, objName);
  };

  handleChangeComboName = (inputName, selectedItem, objName) => {
    if (selectedItem != null) {
      selectedItem.id = selectedItem.name;
    }
    this.handleChangeCombo(inputName, selectedItem, objName);
  };

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  //RITM0946148
  handleChangeComboType = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
  
    const statusCopy = { ...this.state[objName] };
    statusCopy[inputName] = inputValue;
  
    if (inputName == 'idJobPositionType') {
      statusCopy.idJobPosition = null;
    }
  
    this.setState({ [objName]: statusCopy }, () => {
      this.loadRelatedProperties(inputName, inputValue, selectedItem);
    });
  };

  loadRelatedProperties = (inputName, inputValue, selectedItem) => {
    if (inputName == 'idJobPositionType') {
      if (inputValue) this.getJobPostions(inputValue);
      else {
        this.setState({
          appJobPosition: null,
        });
      }
    }
  };

  getJobPostions(parent) {
    try {
      const data = _sortBy(
        (this.props.appAllJobPosition || []).filter((el) => el.idParent == parent && (el.inUse || this.state.model?.idJobPosition == el.id)),
        'name'
      );
      this.setState({
        appJobPosition: data,
      });
    } catch {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        `Error filtering ${entitiesLabels.JOBPOSITION}`
      );
    }
  }

  setEmployer = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state.model };
      statusCopy.idEmployer = employer.id;
      statusCopy.badgeNumber = employer.ghrS_ID;
      statusCopy.fullname = employer.fullname;
      statusCopy.type = 'Saipem';
      //const country = (this.props.appNationality || []).find((el) => el.id == employer.countryId);
      // RITM0586021 ---> if The countyId Field is empty we will select the N/A Country
      const country = (this.props.appNationality || []).find((el) => employer.countryId ? el.id == employer.countryId : el.name === "N/A")

      statusCopy.nationality = country ? country.name : '';

      this.setState({ model: statusCopy, mode: 2 });
    }
  };

  save = () => {
    if (this.validator.allValid()) {
      
      this.state.model.fullname="XXXXX";
      this.state.model.restrictedActivity="restrictedActiviry";
      const dati = this.state.model;

      //RITM1405215
      if(!this.props.isEditModal)
      {
        dati.sequence = (this.props.rows?.length || 0) + 1;
        dati.injuredPersonCode = "IP" + dati.sequence.toString().padStart(2, '0');
      }
      //End

      if (this.isWorkRestricedCase == 2) {
        dati.daysLost = 0;
      } else if (this.isWorkRestricedCase == 1) {
        dati.restrictedWorkDays = 0;
      } else {
        dati.daysLost = 0;
        dati.restrictedWorkDays = 0;
      }

      this.props.save(dati);
        this.saveInjuredPerson(dati);
        this.props.updateAutoOpenInjuredPersonTI(false);
      //showNotification.success(`${entitiesLabels.SUCCESS}`, 'Injured  Person created successfully');
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.INJUREDPEROSN} required fields are missing  `
      );
      this.forceUpdate();
    }
  };


  saveInjuredPerson = (item) => {
      const datiForm = item;
      api
        .put('/incident/', datiForm, `${datiForm.idIncident}/${this.props.autoInjuredPersonModalFromNotification}/investigation/injured/onlysave`) //RITM1064131
        .then((response) => {
          if (response.status == 200) {
            var resp = response.data; //RITM1100465
            this.props.updateHarmedPeople();
            //RITM1100465
            if (resp.notificationDate === '0001-01-01T00:00:00Z')
            {
                showNotification.warning(
                    `${entitiesLabels.WARNING}`,
                    `${getSuccess(
                        entitiesLabels.INJUREDPEROSN,
                        apioperation.PUT
                    )} but the notification has not been sent due to an exception. Please try again later`
                )
            }
            else{
              showNotification.success(
                `${entitiesLabels.SUCCESS}`,
                getSuccess(entitiesLabels.INJUREDPEROSN, apioperation.PUT)
              );
            }
            //End
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.INJUREDPEROSN, apioperation.POST)
          );
        })
        .finally(() => {
        });
  };

  returnBodyParts = (id) => this.state.model.incidentInjuredPersonBodyPart?.find(el => el.idBodyParts === id) ? true : false

  render() {
    const validations = {
      type: this.validator.message("type", this.state.model.type, "required"),
      subContractor: this.validator.message(
        "idSubContractor",
          this.state.model?.type === "Saipem"
          ? true
          : this.state.model.idSubContractor,
        "required"
      ),
      //fullname: this.validator.message('fullname', this.state.model.fullname, 'required'),
      // badgeNumber : this.validator.message('badgeNumber', this.state.model.badgeNumber, 'required'),
      // nationality: this.validator.message(
      //   "nationality",
      //   this.state.model.nationality,
      //   "required"
      // ),
      idInjuryType: this.validator.message(
        "idInjuryType",
        this.state.model.idInjuryType,
        "required"
      ),
      //RITM0864430
      // idContractType: this.validator.message(
      //   "idContractType",
      //   this.state.model.idContractType,
      //   "required"
      // ),
      // employmentDate: this.validator.message(
      //   "employmentDate",
      //   this.state.model.employmentDate,
      //   "required"
      // ),
      // prjJoiningDate: this.validator.message(
      //   "prjJoiningDate",
      //   this.state.model.prjJoiningDate,
      //   "required"
      // ),
      // experienceYears: this.validator.message(
      //   "experienceYears",
      //   this.state.model.experienceYears,
      //   "required|integer"
      // ),
      // experienceMonths: this.validator.message(
      //   "experienceMonths",
      //   this.state.model.experienceMonths,
      //   "required|integer"
      // ),
      // idShiftDuration: this.validator.message(
      //   "idShiftDuration",
      //   this.state.model.idShiftDuration,
      //   "required"
      // ),
      // daysFromShiftStart: this.validator.message(
      //   "daysFromShiftStart",
      //   this.state.model.daysFromShiftStart,
      //   "required|integer"
      // ),
      // hoursFromShiftStart: this.validator.message(
      //   "hoursFromShiftStart",
      //   this.state.model.hoursFromShiftStart,
      //   "required|integer"
      // ),
      // drugAlchoolTest: this.validator.message(
      //   "drugAlchoolTest",
      //   this.state.model.drugAlchoolTest != null,
      //   "accepted"
      // ),
      // daysLost: this.validator.message('drugAlchoolTest', this.state.model.daysLost, 'required|numeric|min:0,num'),
      // restrictedWorkDays: this.validator.message('restrictedWorkDays', this.state.model.restrictedWorkDays, 'required|numeric|min:0,num'),
      // restrictedActivity: this.validator.message(
      //   'restrictedActivity',
      //   this.state.model.restrictedActivity,
      //   'required'
      // ),
      // injuryRecurrent: this.validator.message(
      //   "injuryRecurrent",
      //   this.state.model.injuryRecurrent != null,
      //   "accepted"
      // ),
      // idInjurySource: this.validator.message(
      //   "idInjurySource",
      //   this.state.model.idInjurySource,
      //   "required"
      // ),
      // idInjuryClass: this.validator.message(
      //   "idInjuryClass",
      //   this.state.model.idInjuryClass,
      //   "required"
      // ),

      // GuidBodyPart: this.validator.message(
      // "GuidBodyPart",
      // // this.state.model.idInjuryClass,
      // this.state.model.GuidBodyPart && this.state.model.GuidBodyPart[0],
      // "required"
      // ),

      // incidentInjuredPersonBodyPart: this.validator.message(
      // "incidentInjuredPersonBodyPart",
      // // this.state.model.idInjuryClass,
      // this.state.model.incidentInjuredPersonBodyPart && this.state.model.incidentInjuredPersonBodyPart[0],
      // "required"
      // ),
    };
    const modalHeader = {
      title: this.props.isEditModal ? "Edit " : "Add new ",
      iconDescription: "Close",
      buttonOnClick: () => this.props.toggleModal(false),
    };
    const { title, isOpenModal } = this.props;

    const subTitle1 = "Please, fill-in these 3 fields with preliminary info. They are mandatory for the Notification but you can easily modify them later.";
    const subtitle2 = "Please, fill-in all the mandatory fields to save the section."
    const subtitle = this.props.autoInjuredPersonModalFromNotification ? subTitle1 : subtitle2;
    
    //RITM1197573
    const subContractorsByInfo = this.state.model?.type
      ? (this.props.subContractors || []).filter(
          (el) => (el.inUse || el.id == this.state.model?.idSubContractor) && el.infoOriginator?.name == this.state.model?.type
        )
      : [];

    //RITM1197573
    const appType = (this.props.appType || []).filter(
        (el) => (el.inUse) || this.state.model?.type == el.id);

    const selectedItemCombo = {
      idInjuryType: (this.props.appInjuryType || []).find(
        (el) => el.id == this.state.model.idInjuryType
      ),
      nationality: (this.props.appNationality || []).find(
        (el) => el.name == this.state.model.nationality
      ),
      type: (appType || []).find( //RITM1197573
        (el) => el.id == this.state.model.type
      ),
      subContractor: (subContractorsByInfo || {}).find(
        (el) => el.id == this.state.model?.idSubContractor
      ),
      idContractType: (this.props.appContractType || []).find(
        (el) => el.id == this.state.model.idContractType
      ),
      idShiftDuration: (this.props.appShiftDuration || []).find(
        (el) => el.id == this.state.model.idShiftDuration
      ),
      idJobPositionType: (this.state.appJobPositionType || []).find( //RITM0946148
        (el) => el.id == this.state.model.idJobPositionType
      ),
      idJobPosition: (this.state.appJobPosition || []).find( //RITM0946148
        (el) => el.id == this.state.model.idJobPosition
      ),
      idInjurySource: (this.props.appInjurySource || []).find( 
        (el) => el.id == this.state.model.idInjurySource
      ),
      idInjuryClass: (this.props.appInjuryClass || []).find(
        (el) => el.id == this.state.model.idInjuryClass
      ),
      selectedBodyParts: (this.props.appBodyPart || []).filter(
          (el) =>this.returnBodyParts(el.id))
      // idBodyPart: (this.props.appBodyPart || []).find(
      //   (el) => el.id == this.state.model.idBodyPart
      // ),
    };
  
    this.isWorkRestricedCase =
      selectedItemCombo.idInjuryType != null &&
      selectedItemCombo.idInjuryType?.typology?.includes("Work Restricted")
        ? 2
        : selectedItemCombo.idInjuryType != null &&
          selectedItemCombo.idInjuryType.typology == "Lost Time Injury"
        ? 1
        : 0;

    return this.state.mode == 1 ? (
      <FindGHRSEmployer
        isOpenModal={isOpenModal}
        onCancel={this.handleChangeMode}
        onOk={this.setEmployer}
      />
    ) : (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => false}
      >
        <ModalHeader className="margin-modal" {...modalHeader}>
          <p>{title +": "+ subtitle || ""}</p>
        </ModalHeader>
        <ModalBody className="bx--InjuredPersonModal-content">
        
          {this.state.mode == 0 ? (
            <div className="bx--row two-button-center modal--elemnts-buttons">
              <Button
                kind="primary"
                className="bx--col-md-6"
                onClick={() => this.handleChangeMode(1)}
              >
                GHRS research
              </Button>
              <Button
                kind="primary"
                className="bx--col-md-6"
                onClick={() => this.handleChangeMode(2)}
              >
                Manual input
              </Button>
            </div>
          ) : (
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Type*">
                    {appType == null ? ( //RITM1197573
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="type"
                        placeholder="Select"
                        name="type"
                        alt="model"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : "")}
                        initialSelectedItem={selectedItemCombo.type}
                        // items={this.props.appType.filter((el) => el.name != 'Saipem')}
                        //CR RITM0583314
                        items={appType.filter( //RITM1197573
                          (item) => item.name !== 'SAP')} // Rimuovi l'opzione "SAP" dalla lista //RITM1030537 
                        disabled={this.state.model.idEmployer != null}
                        invalid={validations.type != null}
                      />
                    )}
                    {validations.type}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup
                    legendText={
                      'Category of the Employer' + (selectedItemCombo.type?.name === 'Saipem' ? '' : '*')
                    }
                  >
                    <ComboBox
                      key={
                        "subContractor_" +
                        selectedItemCombo.subContractor?.name +
                        selectedItemCombo.type?.name
                      }
                      id="subContractor"
                      placeholder="Select"
                      name="idSubContractor"
                      alt="model"
                      onChange={this.handleChangeCombo}
                      itemToString={(item) => (item ? item.name : "")}
                      initialSelectedItem={selectedItemCombo.subContractor}
                      items={subContractorsByInfo}
                      disabled={
                        this.state.isDisabled ||
                        selectedItemCombo.type?.name === "Saipem" ||
                        selectedItemCombo.type == null
                      }
                      invalid={validations.subContractor != null}
                    />
                    {validations.subContractor}
                  </FormGroup>
                </div>
                {/* <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Full name*">
                    <TextInput
                      id="txt-fullname"
                      name="fullname"
                      alt="model"
                      placeholder="Input full name"
                      value={this.state.model.fullname || ""}
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                      disabled={this.state.model.idEmployer != null}
                      invalid={validations.fullname != null}
                    />
                    {validations.fullname}
                  </FormGroup>
                </div> */}
                {/* <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Badge number">
                    <TextInput
                      id="badgeNumber"
                      name="badgeNumber"
                      alt="model"
                      placeholder="Input badge number"
                      value={this.state.model.badgeNumber || ""}
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                      disabled={this.state.model.idEmployer != null}
                      // invalid={validations.badgeNumber != null}
                    />
                    {/* {validations.badgeNumber} */} {/*
                  </FormGroup>
                </div> */
                }

                {!this.props.autoInjuredPersonModalFromNotification ? (
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Nationality*">
                    {this.props.appNationality == null ? (
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="nationality"
                        placeholder="Select"
                        name="nationality"
                        alt="model"
                        onChange={this.handleChangeComboName}
                        itemToString={(item) => (item ? item.name : "")}
                        initialSelectedItem={selectedItemCombo.nationality}
                        items={this.props.appNationality}
                        disabled={this.state.model.idEmployer != null}
                        invalid={validations.nationality != null}
                      />
                    )}
                    {validations.nationality}
                  </FormGroup>
                </div>
                ) : (
                  <div className="bx--col-md-4 bx--col-lg-6"></div>
                )}

                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Type of Injury*">
                    {this.props.appInjuryType == null ? (
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="idInjuryType"
                        placeholder="Select"
                        name="idInjuryType"
                        alt="model"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : "")}
                        initialSelectedItem={selectedItemCombo.idInjuryType}
                        items={this.props.appInjuryType}
                        invalid={validations.idInjuryType != null}
                      />
                    )}
                    {validations.idInjuryType}
                  </FormGroup>
                </div>
                {!this.props.autoInjuredPersonModalFromNotification ? (
                <div className="bx--row">
                <div className="bx--col-md-4 bx--col-lg-6">
                   {/* RITM1405215 */}
                  <FormGroup legendText="Type Of Contract">
                    {this.props.appContractType == null ? (
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="idContractType"
                        placeholder="Select"
                        name="idContractType"
                        alt="model"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : "")}
                        initialSelectedItem={selectedItemCombo.idContractType}
                        items={this.props.appContractType}
                        // invalid={validations.idContractType != null}
                      />
                    )}
                    {/* {validations.idContractType} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                   {/* RITM1405215 */}
                  <FormGroup legendText="Employment Date">
                    <DateTimePicker
                      value={this.state.model.employmentDate}
                      type="date"
                      placeholder={DateFormat}
                      name="employmentDate"
                      alt="model"
                      // invalid={validations.employmentDate != null}
                      onChange={this.updateStateDP}
                    />
                    {/* {validations.employmentDate} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6 ">
                   {/* RITM1405215 */}
                  <FormGroup legendText="Prj Joining Date">
                    <DateTimePicker
                      value={this.state.model.prjJoiningDate}
                      type="date"
                      placeholder={DateFormat}
                      name="prjJoiningDate"
                      alt="model"
                      // invalid={validations.prjJoiningDate != null}
                      onChange={this.updateStateDP}
                    />
                    {/* {validations.prjJoiningDate} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Experience in actual position - Years*">
                    <TextInput
                      id="experienceYears"
                      name="experienceYears"
                      alt="model"
                      placeholder=""
                      min={0}
                      value={this.state.model.experienceYears ?? ""}
                      onChange={this.handleChangeModel}
                      type="number"
                      hideLabel
                      labelText=""
                      // invalid={validations.experienceYears != null}
                      pattern="\d+"
                    />
                    {/* {validations.experienceYears} */}
                  </FormGroup>
                </div>
                {/* RITM0946148 */}
                <div className="bx--col-md-4 bx--col-lg-6">
                    <FormGroup legendText="Job Role Type*">
                      {this.state.appJobPositionType == null ? (
                        <DropdownSkeleton />
                        ) : (
                          <ComboBox
                            id="idJobPositionType"
                            placeholder="Select"
                            name="idJobPositionType"
                            alt="model"
                            onChange={this.handleChangeComboType}
                            itemToString={(item) => (item ? item.name : "")}
                            initialSelectedItem={selectedItemCombo.idJobPositionType}
                            items={this.state.appJobPositionType}   
                          />
                      )}                    
                    </FormGroup>                
                </div>
                {/* End */}
                {/* RITM0946148 */}
                <div className="bx--col-md-4 bx--col-lg-6">
                  {/* <FormGroup legendText="Experience in actual position - Month*"> */}
                    {/* <TextInput
                      id="experienceMonths"
                      name="experienceMonths"
                      alt="model"
                      placeholder=""
                      min={0}
                      value={this.state.model.experienceMonths ?? ""}
                      onChange={this.handleChangeModel}
                      type="number"
                      hideLabel
                      labelText=""
                      // invalid={validations.experienceMonths != null}
                    /> */}
                    {/* {validations.experienceMonths} */}
                  {/* </FormGroup> */}
                  <FormGroup legendText="Job Role*">
                  {this.state.appJobPosition == null ? (
                    <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="idJobPosition"
                        placeholder="Select"
                        name="idJobPosition"
                        alt="model"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : "")}
                        initialSelectedItem={selectedItemCombo.idJobPosition}
                        items={this.state.appJobPosition}  
                        disabled={this.state.appJobPosition.length === 0}   
                      />
                  )}                                 
                  </FormGroup>                
                </div>
                {/* End */}
                <div className="bx--col-md-4 bx--col-lg-6">
                   {/* RITM1405215 */}
                  <FormGroup legendText="Shift Duration (days on duty)">
                    {this.props.appShiftDuration == null ? (
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="idShiftDuration"
                        placeholder="Select"
                        name="idShiftDuration"
                        alt="model"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : "")}
                        initialSelectedItem={selectedItemCombo.idShiftDuration}
                        items={this.props.appShiftDuration}
                        // invalid={validations.idShiftDuration != null}
                      />
                    )}
                    {/* {validations.idShiftDuration} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                   {/* RITM1405215 */}
                  <FormGroup legendText="No. of days from shift start">
                    <TextInput
                      id="daysFromShiftStart"
                      name="daysFromShiftStart"
                      alt="model"
                      placeholder=""
                      value={this.state.model.daysFromShiftStart ?? ""}
                      onChange={this.handleChangeModel}
                      type="number"
                      min={0}
                      hideLabel
                      labelText=""
                      // invalid={validations.daysFromShiftStart != null}
                    />
                    {/* {validations.daysFromShiftStart} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                   {/* RITM1405215 */}
                  <FormGroup legendText="No. of hours from shift start">
                    <TextInput
                      id="hoursFromShiftStart"
                      name="hoursFromShiftStart"
                      alt="model"
                      placeholder=""
                      value={this.state.model.hoursFromShiftStart ?? ""}
                      onChange={this.handleChangeModel}
                      type="number"
                      min={0}
                      hideLabel
                      labelText=""
                      // invalid={validations.hoursFromShiftStart != null}
                    />
                    {/* {validations.hoursFromShiftStart} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                   {/* RITM1405215 */}
                  <FormGroup legendText="Drug / Alcohol test required?">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="drugAlchoolTest"
                      onChange={this.handleChangeRadio}
                      orientation="horizontal"
                      valueSelected={
                        this.state.model.drugAlchoolTest != null
                          ? this.state.model.drugAlchoolTest.toString()
                          : ""
                      }
                    >
                      <RadioButton
                        id="drugYes"
                        value="true"
                        labelText="Yes"
                        alt="model"
                      />
                      <RadioButton
                        id="drugNo"
                        value="false"
                        labelText="No"
                        alt="model"
                      />
                    </RadioButtonGroup>
                    {/* {validations.drugAlchoolTest} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Last safety meeting / TBT attended">
                    <DateTimePicker
                      value={this.state.model.lastSafetyMeeting}
                      type="date"
                      placeholder={DateFormat}
                      name="lastSafetyMeeting"
                      alt="model"
                      invalid={validations.lastSafetyMeeting != null}
                      onChange={this.updateStateDP}
                    />
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Last medical check not available">
                    <Checkbox
                      id="lastMedicalCheckAvailable"
                      alt="model"
                      labelText=""
                      checked={
                        this.state.model.lastMedicalCheckAvailable || false
                      }
                      onChange={(value, id) =>
                        this.updateState(id, value, "model")
                      }
                    />
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Last medical check">
                    <DateTimePicker
                      value={this.state.model.lastMedicalCheck}
                      type="date"
                      placeholder={DateFormat}
                      name="lastMedicalCheck"
                      alt="model"
                      invalid={validations.lastMedicalCheck != null}
                      onChange={this.updateStateDP}
                    />
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Last medical check status">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="lastMedicalCheckStatus"
                      onChange={this.handleChangeRadio}
                      orientation="horizontal"
                      valueSelected={
                        this.state.model.lastMedicalCheckStatus || ""
                      }
                    >
                      <RadioButton
                        id="lmcsYes"
                        value="Valid"
                        labelText="Valid"
                        alt="model"
                      />
                      <RadioButton
                        id="lmcsNo"
                        value="Expired"
                        labelText="Expired"
                        alt="model"
                      />
                    </RadioButtonGroup>
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Other info (specify) ">
                    <TextInput
                      id="otherInfo"
                      name="otherInfo"
                      alt="model"
                      placeholder="Input other info"
                      value={this.state.model.otherInfo || ""}
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                    />
                  </FormGroup>
                </div>
                {this.isWorkRestricedCase == 1 ? (
                  <div className="bx--col-md-4 bx--col-lg-6">
                    <FormGroup legendText="Days Lost">
                      <TextInput
                        id="daysLost"
                        name="daysLost"
                        alt="model"
                        min={0}
                        placeholder=""
                        value={this.state.model.daysLost || 0}
                        onChange={this.handleChangeModel}
                        type="number"
                        hideLabel
                        labelText=""
                      />
                    </FormGroup>
                  </div>
                ) : (
                  ""
                )}
                {this.isWorkRestricedCase == 2 ? (
                  <div className="bx--col-md-4 bx--col-lg-6">
                    <FormGroup legendText="Restricted work days">
                      <TextInput
                        id="restrictedWorkDays"
                        name="restrictedWorkDays"
                        alt="model"
                        placeholder=""
                        min={0}
                        value={this.state.model.restrictedWorkDays || 0}
                        onChange={this.handleChangeModel}
                        type="number"
                        hideLabel
                        labelText=""
                        // invalid={validations.restrictedWorkDays != null}
                      />
                      {/* {validations.restrictedWorkDays} */}
                    </FormGroup>
                  </div>
                ) : (
                  ""
                )}
                {/* <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Date fit to original work">
                    <DateTimePicker
                      value={this.state.model.dateFit}
                      type="date"
                      placeholder={DateFormat}
                      name="dateFit"
                      alt="model"
                      invalid={validations.dateFit != null}
                      onChange={this.updateStateDP}
                    />
                  </FormGroup>
                </div> */}
                {/* <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Restricted activity *">
                    <TextInput
                      id="restrictedActivity"
                      name="restrictedActivity"
                      alt="model"
                      placeholder="Input restricted activity"
                      value={this.state.model.restrictedActivity || ''}
                      onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                      invalid={validations.restrictedActivity != null}
                    />
                    {validations.restrictedActivity}
                  </FormGroup>
                </div> */}
                <div className="bx--col-md-4 bx--col-lg-6">
                   {/* RITM1405215 */}
                  <FormGroup legendText="Reoccurrence of a similar injury ">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="injuryRecurrent"
                      onChange={this.handleChangeRadio}
                      orientation="horizontal"
                      valueSelected={
                        this.state.model.injuryRecurrent != null
                          ? this.state.model.injuryRecurrent.toString()
                          : ""
                      }
                    >
                      <RadioButton
                        id="recYes"
                        value="true"
                        labelText="Yes"
                        alt="model"
                      />
                      <RadioButton
                        id="recNo"
                        value="false"
                        labelText="No"
                        alt="model"
                      />
                    </RadioButtonGroup>
                    {/* {validations.injuryRecurrent} */}
                  </FormGroup>
                </div>

                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Source Of Injury*">
                    {this.props.appInjurySource == null ? (
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="idInjurySource"
                        placeholder="Select"
                        name="idInjurySource"
                        alt="model"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : "")}
                        initialSelectedItem={selectedItemCombo.idInjurySource}
                        items={this.props.appInjurySource}
                        //invalid={validations.idInjurySource != null}
                      />
                    )}
                    {/* {validations.idInjurySource} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Classification of the injury*">
                    {this.props.appInjuryClass == null ? (
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="idInjuryClass"
                        placeholder="Select"
                        name="idInjuryClass"
                        alt="model"
                        className="open-up-combo-box"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : "")}
                        initialSelectedItem={selectedItemCombo.idInjuryClass}
                        items={this.props.appInjuryClass}
                        // invalid={validations.idInjuryClass != null}
                      />
                    )}
                    {/* {validations.idInjuryClass} */}
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Body Parts injured in the accident* ">
                    {this.props.appBodyPart == null ? (
                      <DropdownSkeleton />
                    ) : (
                      // aggiunto
                      <MultiSelect
                        direction={this.props.openUp ? "top" : "bottom"}
                        id="GuidBodyPart"
                        invalid={
                        validations.GuidBodyPart != null 
                        }
                        label={
                          this.state.model.incidentInjuredPersonBodyPart?.length < 1 || this.state.model.incidentInjuredPersonBodyPart == null
                            ? "Choose one or more items"
                            :  selectedItemCombo.selectedBodyParts?.map((elem) => elem.name).join(', ')
                        }
                        itemToString={(item) => (item ? item.name : "")}
                        items={this.props.appBodyPart}
                        onChange={this.onChange}
                        type="default"
                        initialSelectedItems={selectedItemCombo.selectedBodyParts}
                      />
                        // <ComboBox
                        //   id="idBodyPart"
                        //   placeholder="Select"
                        //   name="idBodyPart"
                        //   alt="model"
                        //   className="open-up-combo-box"
                        //   onChange={this.handleChangeCombo}
                        //   itemToString={(item) => (item ? item.name : "")}
                        //   initialSelectedItem={selectedItemCombo.idBodyPart}
                        //   items={this.props.appBodyPart}
                        //   invalid={validations.idBodyPart != null}
                        // />
                    )}
                    {/* {validations.GuidBodyPart} */}
                  </FormGroup>
                </div>
                </div>
                        ) : (
                  <div> </div>
                )}
               </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            kind="secondary"
            onClick={() => this.props.toggleModal(false)}
          >
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.save()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}

InjuredPersonModal.propTypes = {
  openUp: PropTypes.bool, // aggiunto
  save: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isEditModal: PropTypes.bool,
  isOpenModal: PropTypes.bool,
  mode: PropTypes.number,
  title: PropTypes.string,
  appType: PropTypes.array,
  appNationality: PropTypes.array,
  appInjuryType: PropTypes.array,
  disabled: PropTypes.bool, // aggiunto
  initialSelectedItems: PropTypes.array, // aggiunto
  onChange: PropTypes.func.isRequired, // aggiunto
};

// aggiunto
InjuredPersonModal.defaultProps = {
  openUp: false,
  invalid: false,
  disabled: false,
  initialSelectedItems: [],
};
export default InjuredPersonModal;
